import { useQuery } from '@apollo/client';
import { useCompanyFeatures } from 'app/domains/companies';
import { useActiveDocument } from 'shared/domains/documents';
import { GetLastDocumentChatDocument } from './getLastChatQuery.gql';
import { stringToReact } from './utils';
export function useGetLastDocumentChat() {
    const { id: documentId } = useActiveDocument();
    const { isFeatureAvailable } = useCompanyFeatures();
    const query = useQuery(GetLastDocumentChatDocument, {
        variables: { documentId },
        skip: !isFeatureAvailable('document-assistant:basic'),
    });
    const { lastChat } = query.data || {};
    const { messages = [], resolutionStatus, resolved = false } = lastChat || {};
    const thread = messages
        .slice(0)
        .reverse()
        .map(message => (Object.assign(Object.assign({}, message), { html: message.content ? stringToReact(message.content) : undefined })));
    return {
        chatId: lastChat === null || lastChat === void 0 ? void 0 : lastChat.id,
        thread,
        loading: query.loading,
        refetch: query.refetch,
        polling: false,
        resolved,
        resolutionStatus,
    };
}
export { GetLastDocumentChatDocument as getLastChatQuery, ChatFragmentFragmentDoc as ChatFragment, MessageFragmentFragmentDoc as MessageFragment, } from './getLastChatQuery.gql';
